<template>
  <BaseLayout>
    <div class="cardLawyer">
      <div class="header">
        <span>点击右上角</span>
        <img class="m-l-10 m-r-20 rightTopImage" src="@/view/card/assets/right-top.png" />
        <span>分享给律所成员</span>
        <img class="shareImage" src="@/view/card/assets/share.png" />
        <img class="rightTopArrowImage" src="@/view/card/assets/right-top-arrow.png" />
      </div>

      <div class="card box-shadow">
        <img v-if="urlQuery.orgIconUrl && avatarUrl" class="avatarImage" :src="avatarUrl" />
        <div v-else class="defaultAvatarImage primary-bg">{{orgName?.substr(0,1)}}</div>
        <div class="chuizi-box">
          <div class="title">{{urlQuery.orgName}}</div>
          <div class="label">邀请您注册并加入律所</div>
          <img class="chuiziImage m-b-20" src="@/view/card/assets/chuizi.png" />
        </div>
        <div class="flex w-100b">
          <ion-button class="f-1 w-100b" color="primary" @click="toRegistered">接受邀请</ion-button>
        </div>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import { ref, reactive, onBeforeMount } from 'vue'
import router from '@/router'
import { getUrlQuery, isUrl } from '@/utils/url.js'
import { fileApi } from '@/apis'

export default {
  setup() {
    document.getElementsByTagName('title')[0].innerText = '律师主任名片'
    const urlQuery = getUrlQuery()
    const orgName = urlQuery.orgName || ''
    const userName = urlQuery.userName || ''
    const avatarUrl = ref('')

    const toRegistered = () => {
      router.push({
        path: '/registered',
        query: { userType: 'lawyer', ...urlQuery },
      })
    }
    onBeforeMount(async () => {
      console.log('urlQuery', urlQuery)
      if (urlQuery.orgIconUrl) {
        avatarUrl.value = await fileApi.getValidUrl({
          id: Number(urlQuery.orgIconUrl),
        })
      }
    })
    return { toRegistered, urlQuery, orgName, userName, avatarUrl }
  },
}
</script>

<style lang="scss">
.cardLawyer {
  height: 100%;
  background-image: url('./assets/lawOffice-bg.png');
  .header {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 40px;
    width: 100%;
    height: 160px;
    background: #ffffff;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.3);
    border-radius: 0px 0px 20px 20px;
    font-size: 28px;
    color: #999;
    .rightTopImage {
      width: 64;
      height: 40px;
    }
    .shareImage {
      width: 88px;
      height: 88px;
    }
    .rightTopArrowImage {
      width: 154px;
      height: 100px;
      position: absolute;
      top: 0;
      right: 28px;
    }
  }
  .chuizi-box {
    display: flex;
    flex-direction: column;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 422px;
    height: 360px;
    .title {
      font-size: 36px;
      color: #333;
      margin-bottom: 20px;
    }
    .label {
      font-size: 28px;
      color: #999;
    }
    .chuiziImage {
      position: absolute;
      top: 0;
      left: 0;
      width: 422px;
      height: 360px;
    }
  }
  .defaultAvatarImage {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    font-size: 36px;
    color: #fff;
  }
  .avatarImage {
    width: 140px;
    height: 140px;
    border-radius: 50%;
  }

  .card {
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;
    margin: 80px 40px;
    padding: 120px 60px 0;
    height: 840px;
    border-radius: 20px;
    background: #fff;
    box-sizing: border-box;
    .card-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
  }
}
</style>